import * as Q from "q";
import { ICacheableQuery } from "Analytics/Scripts/QueryCache/ICacheableQuery";
import { CoreHttpClient4 } from "TFS/Core/RestClient";
import { WebApiTeam } from "TFS/Core/Contracts";
import * as Service from "VSS/Service";

/** REST-backed query for team information.  */
export class TeamQuery implements ICacheableQuery<WebApiTeam> {
    constructor(private projectId: string, private teamId: string) {}

    public getKey(): string {
        return `${this.getQueryName()}.${this.projectId}.${this.teamId}`;
    }

    public getQueryName(): string {
        return "TeamQuery";
    }

    public runQuery(): IPromise<WebApiTeam> {
        const restClient = Service.getClient(CoreHttpClient4);
        return restClient.getTeam(this.projectId, this.teamId);
    }
}
